// extracted by mini-css-extract-plugin
export default {"root":"aodIv","scrollable":"_1lWBz","size-small":"_2xPec","sizeSmall":"_2xPec","size-medium":"wT4l_","sizeMedium":"wT4l_","tag-item":"_2W9VQ","tagItem":"_2W9VQ"};